export class CertsChart {
    all: any = null;
    full: any = [];
    today: any = null;
}
